<template>
  <div
    v-if="event.training_protocol"
    class="pa-6"
  >
    <div class="font-weight-medium mb-1">
      {{ event.training_protocol.name }}
    </div>
    <v-card
      outlined
      class="pa-2 grey--text text--darken-2"
    >
      {{ event.training_protocol.description }}
    </v-card>

    <v-row
      no-gutters
      class="mb-2 mt-6 grey--text text-body-2"
      align="center"
    >
      <v-col>{{ $t('card_title.protocol_exercises') }}</v-col>
      <v-col cols="auto">
        <v-btn
          v-if="$can('edit-training-protocols')"
          text
          small
          class="text-none"
          :loading="updating"
          @click="exercisesPeriodsDialog = true"
        >
          <v-icon
            left
            small
          >
            far fa-clock
          </v-icon>
          {{ $t('button.add_timings') }}
        </v-btn>
        <v-btn
          v-if="$can('edit-training-protocols')"
          text
          small
          color="primary"
          class="text-none"
          :loading="updating"
          @click="exercisesDialog = true"
        >
          <v-icon
            left
            small
          >
            far fa-pen
          </v-icon>
          {{ $t('button.adjust_protocol') }}
        </v-btn>
      </v-col>
    </v-row>

    <div
      v-for="exercise in event.training_exercises"
      :key="exercise.id"
      class="mb-1"
    >
      <superset-selected-card
        v-if="exercise.type === 'superset'"
        :orderable="false"
        :editable="false"
        show-media
        :item.sync="exercise"
      />
      <group-selected-card
        v-else-if="exercise.type === 'group'"
        :item.sync="exercise"
        show-media
        :editable="false"
        :orderable="false"
      />
      <pause-selected-card
        v-else-if="exercise.type === 'pause'"
        :item.sync="exercise"
        show-media
        :editable="false"
        :orderable="false"
      />
      <exercise-selected-card-template
        v-else-if="exercise.group"
        :exercise="exercise"
        :orderable="false"
        :editable="false"
        show-media
      />
    </div>

    <training-protocol-form-dialog
      :visible.sync="exercisesDialog"
      :edit-items="event.training_exercises"
      :listen-events="false"
      :edit-title="event.training_protocol ? event.training_protocol.name : undefined"
      :edit-description="event.training_protocol ? event.training_protocol.description : undefined"
      @update:edit-items="updateTrainingExercises"
    />

    <exercises-periods-dialog
      :visible.sync="exercisesPeriodsDialog"
      :training-exercises="event.training_exercises"
      :event="event"
      @update:edit-items="updateTrainingExercises"
    />
  </div>
</template>

<script>
import deleteConfirmationMixin from '@/mixins/deleteConfirmationMixin'
import SupersetSelectedCard from '@/components/training-builder/SupersetSelectedCard.vue'
import { EventApiService } from '@/data/services'
import GroupSelectedCard from '@/components/training-builder/GroupSelectedCard.vue'
import TrainingProtocolFormDialog from '@/components/dialogs/TrainingProtocolFormDialog.vue'
import PauseSelectedCard from '@/components/training-builder/PauseSelectedCard.vue'
import ExerciseSelectedCardTemplate from '@/components/training-builder/ExerciseSelectedCardTemplate.vue'
import ExercisesPeriodsDialog from '@/components/training-builder/ExercisesPeriodsDialog.vue'

export default {
  name: 'EventTrainingProtocol',
  components: {
    ExercisesPeriodsDialog,
    ExerciseSelectedCardTemplate,
    PauseSelectedCard,
    TrainingProtocolFormDialog,
    GroupSelectedCard,
    SupersetSelectedCard
  },
  mixins: [deleteConfirmationMixin],
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    updating: false,
    exercisesDialog: false,
    exercisesPeriodsDialog: false
  }),
  created() {
  },
  methods: {
    async updateTrainingExercises(exercises) {
      try {
        this.updating = true

        await EventApiService.update({
          id: this.event.id,
          training_exercises: exercises
        })

        this.$emit('update')

        this.$store.dispatch(this.$storeActions.ALERT, {
          text: this.$t('alert.training_protocol_updated.success'),
          color: 'success'
        })
      } catch (e) {

      } finally {
        this.updating = false
      }
    }
  }
}
</script>
